import { useBinaryStateMachine } from "../../common/useBinaryStateMachine";

export const useDisabledControlsWhilstRemoving = ({ isEnabled }) => {
  const [isControlsEnabled, setControlsEnabled] = useBinaryStateMachine({
    ambientState: isEnabled
  });

  return { isControlsEnabled, setControlsEnabled };
};
